import ReactGA from 'react-ga4';

const GAMeasurementId = 'G-NB12KPBGEK';

export const initializeGoogleAnalytics = () => {
  ReactGA.initialize(GAMeasurementId);
};
